import Component from '../abstracts/Component';

export default class DominationComponent extends Component {

  get SELECTORS() {
    return {
      main: '.widget-domination',
      caption: '.widget-domination figcaption'
    };
  }

  constructor() {
    super();
  }


  checkVisibility(elem) {
    let img = elem.querySelector('img');
    let caption = elem.querySelector('figcaption');
    let bounding = img.getBoundingClientRect();
    let imgHeight = img.clientHeight;
    let captionHeight = caption.clientHeight;
    let refHeight = imgHeight + captionHeight;
    let winHeight = window.innerHeight;

    if (bounding.top + refHeight >= winHeight && bounding.top + refHeight / 5  <= winHeight ) {
      return true
    } else {
      return false
    }
  }

  handleIntersection(scrollDir) {
    let elem = document.querySelector(this.SELECTORS.main);
    let caption = document.querySelector(this.SELECTORS.caption);
    let isVisibile = this.checkVisibility(elem);
    if(caption){
      if(scrollDir == 'down') {
        if(isVisibile) {
          caption.classList.add('sticky-in');
        } else {
          caption.classList.remove('sticky-in');
        }
      } else {
        caption.classList.remove('sticky-in');
      }
    }

  }

  render() {
    if (!document.querySelector(this.SELECTORS.main) || !document.querySelector(this.SELECTORS.caption)) return;

    let scrollPos = 0;
    const scrollElement = document.body;

    window.addEventListener('scroll', (e) => {
      let scrollDir = '';

      if ( (scrollElement.getBoundingClientRect()).top > scrollPos) {
        scrollDir = 'up'
      } else {
        scrollDir = 'down'
      }
      scrollPos = (scrollElement.getBoundingClientRect()).top;

      this.handleIntersection(scrollDir);
    }, true );
  }
}

